import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetDepartmentQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetDepartmentQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/departments/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}